<script>
// import i18n from "../i18n";
import router from "@/router";
import { layoutComputed } from "../state/helper";
import { mapActions,mapGetters, mapState } from "vuex";
import ManagementTreeDropdown from "@/components/management-tree-dropdown";
import CameraView from "@/components/camera"
import AlertMessages from '@/components/alerts/alert'
export default {
  props: {
    // type: {
    //   type: String,
    //   required: true,
    // },
    // width: {
    //   type: String,
    //   required: true,
    // },
  },
  computed: {
    ...layoutComputed,
    ...mapGetters('auth',['getProfileDetails']),
    ...mapGetters("attendance", ["getAttendanceState"]),
    ...mapState(['Username','fullLocation']),
  },
  components: { ManagementTreeDropdown, CameraView, AlertMessages },
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: "en",
    };
  },
  methods: {
    ...mapActions('auth', ['logout']),
        async Logout() {
            await this.$store.dispatch("globalReset");
            await this.logout(); // Call the logout action
            this.$router.push({ name: 'Login' });
        },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width > 991) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    // toggleMenu() {
    //   let element = document.getElementById("topnav-menu-content");
    //   element.classList.toggle("show");
    // },
  },
  mounted() {
    
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            case "colored":
              document.body.setAttribute("data-topbar", "colored");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "boxed":
              document.body.setAttribute("data-layout-size", "boxed");
              break;
            case "fluid":
              document.body.setAttribute("data-layout-mode", "fluid");
              document.body.removeAttribute("data-layout-size");
              break;
            default:
              document.body.setAttribute("data-layout-mode", "fluid");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <AlertMessages/>
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/dashboard" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-icon.svg" alt height="35" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/ytm-dark.svg" alt height="55" />
            </span>
          </a>

          <a href="/dashboard" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-icon.svg" alt height="35" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/ytm.svg" alt height="55" />
            </span>
          </a>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item"
          data-toggle="collapse"
          @click="toggleMenu"
        >
          <i class="ri-close-line align-middle"></i>
        </button>        
      </div>

      <div class="d-flex align-items-center">
        <div class="dropdown d-inline-block d-lg-none">
          <!-- <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            id="page-header-search-dropdown"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="ri-search-line"></i>
          </button> -->
          <div
            class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
            aria-labelledby="page-header-search-dropdown"
          >
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search ..."
                  />
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit">
                      <i class="ri-search-line"></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>        
        <div class="mr-3 overflow-hidden mw-200 d-sm-none d-none d-md-block d-lg-block location" v-if="this.getAttendanceState?.message != 'Pending' && fullLocation !=''">
          <p class="text-light mb-0 text-truncate" :title="fullLocation"><i class="ri-map-pin-line"></i>  {{fullLocation}}</p>
        </div>
        <div class="mr-2">
          <CameraView/>
        </div>
        <div>
          <ManagementTreeDropdown/>
        </div>
        <div class="dropdown d-none d-lg-inline-block ml-1">
          <button
            type="button"
            class="btn header-item noti-icon waves-effect"
            data-toggle="fullscreen"
            @click="initFullScreen"
          >
            <i class="ri-fullscreen-line"></i>
          </button>
        </div>

        <!-- <b-dropdown
          right
          menu-class="dropdown-menu-lg p-0"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="ri-notification-3-line"></i>
            <span class="noti-dot"></span>
          </template>
          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
              <div class="col-auto">
                <a href="#!" class="small">
                  {{
                  $t("navbar.dropdown.notification.subtext")
                }}
                </a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a href class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs mr-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="ri-notification-line"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    New notification
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      Notification text
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.order.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/users/man.png"
                  class="mr-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    New Project Name
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      Project task name
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.james.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href class="text-reset notification-item">
              <div class="media">
                <div class="avatar-xs mr-3">
                  <span
                    class="avatar-title bg-success rounded-circle font-size-16"
                  >
                    <i class="ri-checkbox-circle-line"></i>
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    New notification 
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                     Notification text
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.item.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <a href class="text-reset notification-item">
              <div class="media">
                <img
                  src="@/assets/images/users/user.png"
                  class="mr-3 rounded-circle avatar-xs"
                  alt="user-pic"
                />
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    Notification title
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      Notification text
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline"></i>
                      {{ $t("navbar.dropdown.notification.salena.time") }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top">
            <a
              class="btn btn-sm btn-link font-size-14 btn-block text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle mr-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </a>
          </div>
        </b-dropdown> -->

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <div class="d-flex align-items-center">
              <img v-if="!getProfileDetails?.ImgUrl"
                class="rounded-circle header-profile-user"
                src="@/assets/images/users/user.png"
                alt="Header Avatar"
              />
              <img v-else
                class="rounded-circle header-profile-user"
                :src='getProfileDetails?.ImgUrl'
                alt=""
              />
              <span class="d-none d-xl-inline-block ml-1 text-truncate mw-150 align-text-bottom" :title="Username">
                {{ getProfileDetails.FirstName}} {{ getProfileDetails.LastName }}
              </span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
            </div>
          </template>
          <!-- item-->
          <a class="dropdown-item d-lg-none" exact-active-class="active">
           <li class="nav-item dropdown">  
             <i class="ri-calendar-check-fill align-middle"></i>
                Mark attendance
                </li>
                </a>
          <div class="dropdown-divider  d-lg-none"></div>
          <a class="dropdown-item" @click="$router.push('/settings')"> 
            <i class="ri-user-line align-bottom "></i>
            Profile
            <!-- {{ $t("navbar.dropdown.kevin.list.profile") }} -->
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" @click="Logout()" href="/">
            <i class="ri-logout-box-r-line align-bottom text-danger"></i>
            Log out
            <!-- {{ $t("navbar.dropdown.kevin.list.logout") }} -->
            <!-- @click="Logout()" -->
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.navbar-brand-box{
  @media screen and (max-width:560px) {
    display: none;    
  }
}

.location{
  @media screen and (min-width: 1200px) and (max-width:1300px){
    width: 124px;
  }
}
</style>